/**
 * "Make Every Query Count" Tip
 *
 * Shows once for trial users on the chat dashboard.
 * Reminds them that the trial is small (6 queries total over 3 days),
 * so each one should be their best/hardest question.
 *
 * Dismissible — persists per browser via localStorage.
 * Renders nothing for paid tiers or after first dismissal.
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './MakeEveryQueryCountTip.css';

const STORAGE_KEY = 'sb_query_count_tip_dismissed_v1';

export const MakeEveryQueryCountTip = ({ tierStatus }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!tierStatus || !tierStatus.is_trial) return;
    if (localStorage.getItem(STORAGE_KEY) === '1') return;
    setVisible(true);
  }, [tierStatus]);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div className="meqc-tip" data-testid="meqc-tip" role="note">
      <span className="meqc-icon" aria-hidden>💡</span>
      <div className="meqc-body">
        <strong className="meqc-title">{t('tip.title')}</strong>
        <span className="meqc-text">{t('tip.body')}</span>
      </div>
      <button
        className="meqc-dismiss"
        onClick={dismiss}
        aria-label={t('common.close')}
        data-testid="meqc-dismiss"
      >
        ✕
      </button>
    </div>
  );
};

export default MakeEveryQueryCountTip;
